import { Message } from "./Message";
/**
 * レベル定数
 */
export const LEVEL: { INFO: "INFO"; WARN: "WARN"; ERROR: "ERROR" } = {
  INFO: "INFO",
  WARN: "WARN",
  ERROR: "ERROR",
};

/**
 * メッセージ定義
 */
export class MessageDefine {
  private _level: "INFO" | "WARN" | "ERROR";
  private _id: string;
  private _message: string;
  private _basicMessage: string;

  constructor(level: "INFO" | "WARN" | "ERROR", id: string, message: string) {
    this._level = level;
    this._id = id;
    this._message = message;
    this._basicMessage = message;
  }

  /**
   * メッセージ取得
   */
  public getMessage: (param?: Array<any>) => Message = (param?: Array<any>) => {
    if (param != undefined) {
      switch (param.length) {
        case 0:
          break;
        case 1:
          this._message = this._basicMessage.replace(/\{0}/g, param[0]);
          break;
        case 2:
          if (this._id == "E0001") {
            let systemName = "";
            if (param[0]) {
              if (
                param[0]?.includes(process.env.VUE_APP_DRM_NODE_API_URL) ||
                param[0].includes(process.env.VUE_APP_DRM_LINK_API_URL) ||
                param[0].includes(
                  process.env.VUE_APP_DRM_CONSOLIDATE_API_URL
                ) ||
                param[0].includes(process.env.VUE_APP_DRM_NODE_PRV_XYZ_URL) ||
                param[0].includes(process.env.VUE_APP_DRM_LINK_PRV_XYZ_URL) ||
                param[0].includes(process.env.VUE_APP_DRM_NODE_BASIC_XYZ_URL) ||
                param[0].includes(process.env.VUE_APP_DRM_LINK_BASIC_XYZ_URL)
              ) {
                systemName = "DRM-DB";
              } else if (
                param[0].includes(
                  process.env.VUE_APP_ROAD_STRUCTURES_DB_API_URL
                )
              ) {
                systemName = "点検DB";
              } else if (
                param[0].includes(process.env.VUE_APP_DOROKIBAN_API_URL)
              ) {
                systemName = "道路基盤地図";
              } else if (
                param[0].includes(process.env.VUE_APP_GEOCODE_API_URL)
              ) {
                systemName = "住所検索";
              } else {
                systemName = "連携基盤";
              }
            }
            this._message = this._basicMessage.replace(/\{S}/g, systemName);
            this._message = this._message.replace(/\{0}/g, param[0]);
            this._message = this._message.replace(/\{1}/g, param[1]);
            break;
          } else {
            this._message = this._basicMessage.replace(/\{0}/g, param[0]);
            this._message = this._message.replace(/\{1}/g, param[1]);
            break;
          }
        case 3:
          this._message = this._basicMessage.replace(/\{0}/g, param[0]);
          this._message = this._message.replace(/\{1}/g, param[1]);
          this._message = this._message.replace(/\{2}/g, param[2]);
          break;
      }
    }
    return new Message(this._level, this._id, this._message);
  };

  /**
   * @tutorial W0001:{0}は入力必須項目です。
   */
  public static W0001: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0001",
    "{0}は入力必須項目です。"
  );

  /**
   * @tutorial W0002:入力されている緯度経度は不正です。
   */
  public static W0002: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0002",
    "入力されている緯度経度は不正です。"
  );

  /**
   * @tutorial W0003:{0}または{1}を入力してください。
   */
  public static W0003: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0003",
    "{0}または{1}を入力してください。"
  );

  /**
   * @tutorial W0004:{0}には{1}文字以上にしてください。
   */
  public static W0004: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0004",
    "{0}には{1}文字以上にしてください。"
  );

  /**
   * @tutorial W0005:{0}には{1}文字以下にしてください。
   */
  public static W0005: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0005",
    "{0}には{1}文字以下にしてください。"
  );

  /**
   * @tutorial W0006:{0}には半角数字で入力してください。
   */
  public static W0006: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0006",
    "{0}には半角数字で入力してください。"
  );

  /**
   * @tutorial W0007:{0}には整数部{1}桁、小数部{2}桁までの数値を入力してください。
   */
  public static W0007: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0007",
    "{0}には整数部{1}桁、小数部{2}桁までの数値を入力してください。"
  );

  /**
   * @tutorial W0008:{0}には正しい日付を入力してください。
   */
  public static W0008: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0008",
    "{0}には正しい日付を入力してください。"
  );

  /**
   * @tutorial W0009:{0}には{1}から{2}までの範囲で入力してください。
   */
  public static W0009: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0009",
    "{0}には{1}から{2}までの範囲で入力してください。"
  );

  /**
   * @tutorial W0010:選択されたファイルのフォーマットが不正です。
   */
  public static W0010: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0010",
    "選択されたファイルのフォーマットが不正です。"
  );

  /**
   * @tutorial W0011:同時に表示可能な属性画面数は{0}画面までです。\r\n画面を閉じてから再度実行してください。
   */
  public static W0011: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0011",
    "同時に表示可能な属性画面数は{0}画面までです。\r\n画面を閉じてから再度実行してください。"
  );

  /**
   * @tutorial W0012:作図中の図形が交差しているため、計測点を追加できません。\r\n交差しない位置に計測点を追加してください。
   */
  public static W0012: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0012",
    "作図中の図形が交差しているため、計測点を追加できません。\r\n交差しない位置に計測点を追加してください。"
  );

  /**
   * @tutorial W0013:計測点が3点未満のため、計測できません。\r\n計測点は3点以上を指定してください。
   */
  public static W0013: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0013",
    "計測点が3点未満のため、計測できません。\r\n計測点は3点以上を指定してください。"
  );

  /**
   * @tutorial W0014:ログインIDまたはパスワードが正しくありません。
   */
  public static W0014: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0014",
    "ログインIDまたはパスワードが正しくありません。"
  );

  /**
   * @tutorial W0015:{0}には{1}より大きな値を入力してください。
   */
  public static W0015: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0015",
    "{0}には{1}より大きな値を入力してください。"
  );

  /**
   * @tutorial W0016:選択範囲に地物がありませんでした。出力対象を再指定してください。
   */
  public static W0016: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0016",
    "選択範囲に地物がありませんでした。出力対象を再指定してください。"
  );

  /**
   * @tutorial W0017:サイドメニューで複数の種類が指定されています。\r\n表示対象を１種類に変更し、再度実行してください。
   */
  public static W0017: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0017",
    "サイドメニューで複数の種類が指定されています。\r\n表示対象を１種類に変更し、再度実行してください。"
  );

  /**
   * @tutorial W0018:認証情報の有効期限が切れています。\r\nログインから再度実行してください。
   */
  public static W0018: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0018",
    "認証情報の有効期限が切れています。\r\nログインから再度実行してください。"
  );

  /**
   * @tutorial W0019:出力対象がないため、出力できません。
   */
  public static W0019: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0019",
    "出力対象がないため、出力できません。"
  );

  /**
   * @tutorial W0020:本データは市区町村出力機能の対象外となります。\r\n市区町村出力対象データは以下の通りです。\r\n交通量データ、一般交通量調査データ、OD、交通事故統計情報、ロードキル
   */
  public static W0020: MessageDefine = new MessageDefine(
    LEVEL.WARN,
    "W0020",
    "本データは市区町村出力機能の対象外となります。\r\n市区町村出力対象データは以下の通りです。\r\n交通量データ、一般交通量調査データ、OD、交通事故統計情報、ロードキル"
  );

  /**
   * @tutorial E0001:{S}サーバへのアクセスに失敗しました。\r\nしばらく時間をおいてから再度お試しください。\r\nそれでも解決しない場合は管理者に問い合わせください。\r\n接続先サーバURL:{0}\r\nエラーコード:{1}
   */
  public static E0001: MessageDefine = new MessageDefine(
    LEVEL.ERROR,
    "E0001",
    "{S}サーバへのアクセスに失敗しました。\r\nしばらく時間をおいてから再度お試しください。\r\nそれでも解決しない場合は管理者に問い合わせください。\r\n接続先サーバURL:{0}\r\nエラーコード:{1}"
  );

  /**
   * @tutorial E0002:想定外エラーが発生しました。管理者に問い合わせください。\r\nエラー詳細:{0}
   */
  public static E0002: MessageDefine = new MessageDefine(
    LEVEL.ERROR,
    "E0002",
    "想定外エラーが発生しました。管理者に問い合わせください。\r\nエラー詳細:{0}"
  );

  /**
   * @tutorial I0001:ベクタデータをクリアします。よろしいですか。
   */
  public static I0001: MessageDefine = new MessageDefine(
    LEVEL.INFO,
    "I0001",
    "ベクタデータをクリアします。よろしいですか。"
  );

  /**
   * @tutorial I0002:{0}のデータは{1}～{2}の範囲で入力してください。\r\n
   */
  public static I0002: MessageDefine = new MessageDefine(
    LEVEL.INFO,
    "I0002",
    "{0}のデータは{1}～{2}の範囲で入力してください。\r\n"
  );

  /**
   * @tutorial I0003:選択された期間はデータが保管されていません。\r\n
   */
  public static I0003: MessageDefine = new MessageDefine(
    LEVEL.INFO,
    "I0003",
    "選択された期間はデータが保管されていません。\r\n"
  );
  /**
   * @tutorial I0004:ファイルが出力されました。
   */
  public static I0004: MessageDefine = new MessageDefine(
    LEVEL.INFO,
    "I0004",
    "ファイルが出力されました。"
  );
}
